import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Typography,
  Button,
} from "@mui/material"
import {
  ButtonWrapper,
  ModalCard,
  ModalContent,
  ModalHeader,
  Spacer,
} from "./MoveInvoiceModal.styles"
import { useInvoiceQueues, useMoveInvoices } from "../../hooks"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import { openInvoices } from "../../activeScreenSlice"
import { useEffect, useState } from "react"
import { useInvoiceIds } from "../../hooks"
import { selectActivePage } from "../../activeScreenSlice"

export interface Props {
  open: boolean
  onClose: () => void
  invoiceIds: number[]
  invoiceData?: any
}

export default function MoveInvoiceModal(props: Props) {
  const mutation = useMoveInvoices()
  const dispatch = useAppDispatch()
  const { data, isError } = useInvoiceQueues(false)
  const [selectedQueue, setSelectedQueue] = useState<number | undefined>()
  const [filteredInvoices, setFilteredInvoices] = useState([]);
  const [finalRows, setFinalRows] = useState([]);
  const initialValuesQuery = useInvoiceIds(props.invoiceIds!)
  const activePage = useAppSelector(selectActivePage)
  const [hasMulOpco, setMultipleOpco]=useState<boolean>(false);

  useEffect(() => {
    if (activePage.activeScreen === "invoiceDetail") {
      initialValuesQuery.refetch();
    }
  }, [activePage.activeScreen]);


  useEffect(()=>{
    if(initialValuesQuery?.data) {
      setFilteredInvoices(initialValuesQuery?.data);
    }
  },[initialValuesQuery])


  function handleSubmit() {
    if (selectedQueue) {
      mutation.mutate(
        { invoiceIds: props.invoiceIds, queueId: selectedQueue },
        {
          onSuccess: () => {
            props.onClose()
            dispatch(openInvoices())
          },
        },
      )
    }
    setSelectedQueue(undefined);
  }
  const onCloseHandler = () => {
    setSelectedQueue(undefined);
    props.onClose();
  };

  useEffect(()=>{
    let mulOpcoFlag=false;
    let opcoName="";
    let rowsNew=[];
      if(data?.length > 0 && filteredInvoices?.length > 0) {
        for (let i = 0; i < data?.length; i++) {
        for (let j = 0; j < filteredInvoices.length; j++) {
          if (data[i]?.opco_name?.toLowerCase() === filteredInvoices[j]?.opco?.name?.toLowerCase()) {
            if(rowsNew.indexOf(data[i])<0) {
              if(opcoName !== "" && opcoName !== filteredInvoices[j]?.opco?.name) {
                mulOpcoFlag=true;
              }
              setMultipleOpco(mulOpcoFlag);
              opcoName=filteredInvoices[j]?.opco?.name;
              rowsNew.push(data[i]);
            }
          }
        }
      }
    }
    setFinalRows(rowsNew);
  },[data,filteredInvoices, props.open])

  return (
    <Modal open={props.open} onClose={onCloseHandler}>
      <ModalCard>
        <ModalHeader>You are about to move invoices</ModalHeader>
        {!hasMulOpco && <>
        {props.invoiceIds.length > 1 && (
          <ModalContent>
            Please select the worklist to move invoices to:
          </ModalContent>
        )}
        {props.invoiceIds.length < 2 && (
          <ModalContent>
            Please select the worklist to move invoice to:
          </ModalContent>
        )}
        {isError && (
          <Typography>
            An error has occurred fetching work queue lists
          </Typography>
        )}</>}
        <FormControl fullWidth>
          {!hasMulOpco && <><InputLabel>Queue</InputLabel>
          <Select
            value={selectedQueue ?? ""}
            label="Queue"
            onChange={(e) => setSelectedQueue(Number(e.target.value))}
          >
            {finalRows && finalRows.map(menuData=>(
              <MenuItem key={menuData.id} value={menuData.id}>
                {menuData.name}
              </MenuItem>
            ))}
          </Select></>}
          {hasMulOpco && <Typography sx={{color: "rgb(217, 65, 92)"}}>Note: Selecting invoices across different operating companies is not permitted. Please select invoices belonging to the same business unit and try again.</Typography>}
        </FormControl>
        <ButtonWrapper sx={{padding: '8px 0'}}>
          <Spacer />

          <Button
              variant="outlined"
              onClick={onCloseHandler}
          >
              Cancel
          </Button>
          {!hasMulOpco && <Button
              variant="contained"
              onClick={handleSubmit}
          >
              Move
          </Button>}
        </ButtonWrapper>
      </ModalCard>
    </Modal>
  )
}

